const ROLE_PERMISSION = [{
    name: '管理员',
    permission: [{
        arrIndex: 0,
        children: [0, 1]
    }, {
        arrIndex: 1,
        children: [0, 1]
    }, {
        arrIndex: 2,
        children: [0, 1, 2]
    }, {
        arrIndex: 7,
        children: [0, 1]
    }, {
        arrIndex: 10,
        children: [0, 1]
    }, {
        arrIndex: 11,
        children: [0]
    }]
}, {
    name: '开发者',
    permission: [{
        arrIndex: 0,
        children: [0, 1]
    }, {
        arrIndex: 2,
        children: [0, 1, 2]
    }, {
        arrIndex: 7,
        children: [0, 1]
    }, {
        arrIndex: 10,
        children: [0, 1]
    }, {
        arrIndex: 11,
        children: [0]
    }]
}, {
    name: '执行者',
    permission: [{
        arrIndex: 2,
        children: [0, 2]
    }]
}, {
    name: '媒介',
    permission: [{
        arrIndex: 2,
        children: [2]
    }]
}, {
    name: '运营',
    permission: [{
        arrIndex: 2,
        children: [0, 2]
    }]
}, {
    name: '普通用户',
    permission: null
}, {
    name: 'C端业务管理员',
    permission: [{
        arrIndex: 2,
        children: [0, 2]
    }, {
        arrIndex: 10,
        children: [0, 1]
    }, {
        arrIndex: 11,
        children: [0]
    }]
}, {
    name: 'C端业务专员',
    permission: [{
        arrIndex: 10,
        children: [0, 1]
    }, {
        arrIndex: 11,
        children: [0]
    }]
}];
export default ROLE_PERMISSION;


// WEBPACK FOOTER //
// ./src/config/top_nav/permission.js